export default {
    limites: [],
    limite: {},
    usuariosLimite: []
}